import { render } from "./IconPayment.vue?vue&type=template&id=5f24806f&scoped=true&ts=true"
import script from "./IconPayment.vue?vue&type=script&lang=ts"
export * from "./IconPayment.vue?vue&type=script&lang=ts"

import "./IconPayment.vue?vue&type=style&index=0&id=5f24806f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f24806f"]])

export default __exports__